









import {
  ContentType,
  SubjectiveContent,
} from '@/resource/question/question.type';
import { Component, Vue, Prop } from 'vue-property-decorator';
import SubjectiveParent from '@/components/questions/subjective-components/SubjectiveParent.vue';
import SubjectiveText from '@/components/questions/subjective-components/SubjectiveText.vue';
import SubjectiveAnswer from '@/components/questions/subjective-components/SubjectiveAnswer.vue';
import SubjectiveImage from '@/components/questions/subjective-components/SubjectiveImage.vue';
import SubjectiveList from '@/components/questions/subjective-components/SubjectiveList.vue';
import SubjectiveFillBlank from '@/components/questions/subjective-components/SubjectiveFillBlank.vue';
import SubjectiveAttachment from '@/components/questions/subjective-components/SubjectiveAttachment.vue';
import SubjectiveTable from '@/components/questions/subjective-components/SubjectiveTable.vue';

@Component({
  components: {
    SubjectiveParent,
    SubjectiveText,
    SubjectiveAnswer,
    SubjectiveImage,
    SubjectiveList,
    SubjectiveFillBlank,
    SubjectiveAttachment,
    SubjectiveTable,
  },
})
export default class ComponentSubjective extends Vue {
  @Prop({ required: true })
  content!: SubjectiveContent;

  getComponent(contentType: ContentType): string {
    let compName = '';

    switch (contentType) {
      case ContentType.Parent:
        compName = 'SubjectiveParent';
        break;
      case ContentType.Text:
        compName = 'SubjectiveText';
        break;
      case ContentType.Answer:
        compName = 'SubjectiveAnswer';
        break;
      case ContentType.Image:
        compName = 'SubjectiveImage';
        break;
      case ContentType.List:
        compName = 'SubjectiveList';
        break;
      case ContentType.FillInBlank:
        compName = 'SubjectiveFillBlank';
        break;
      case ContentType.Attachment:
        compName = 'SubjectiveAttachment';
        break;
      case ContentType.Table:
        compName = 'SubjectiveTable';
        break;
    }

    return compName;
  }
}
